import { createRequestTypes } from 'common/websocket-redux';

export const RESEND_PAYMENT_SELECTED =
  'cust-care/payments/RESEND_PAYMENT_SELECTED';

export const RETRY_INTERAC_PAYMENT = createRequestTypes(
  'cust-care/payments/RETRY_INTERAC_PAYMENT',
);
